/*
  Zoppy - injeta zoppy-popup-v1.css dentro do Shadow DOM fechado do pop-up.
  O loader da Zoppy cria o pop-up em div[data-zoppy-popup] com shadow root
  "closed", entao o CSS do tema nao chega la. Este script guarda a
  referencia de cada shadow root criado (sem mudar o modo dele) e, quando
  o host do pop-up aparece, anexa a folha de estilo.

  DEVE carregar antes do loader da Zoppy (script sincrono, sem defer/async).
  A URL do CSS vem do atributo data-css da tag <script> (ver theme.liquid).
*/
(function () {
  var script = document.currentScript;
  var cssUrl = script && script.getAttribute('data-css');
  if (!cssUrl || !Element.prototype.attachShadow) return;

  var roots = new WeakMap();
  var original = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = original.call(this, init);
    roots.set(this, root);
    return root;
  };

  var sheet = null;
  var waiting = [];

  function apply(host) {
    var root = roots.get(host);
    if (!root || root.__adaZoppy) return;
    root.__adaZoppy = true;
    if ('adoptedStyleSheets' in root) {
      root.adoptedStyleSheets = root.adoptedStyleSheets.concat(sheet);
    } else {
      var style = document.createElement('style');
      style.textContent = sheet.cssText;
      root.appendChild(style);
    }
  }

  function handle(host) {
    if (sheet) apply(host);
    else waiting.push(host);
  }

  fetch(cssUrl)
    .then(function (r) {
      return r.text();
    })
    .then(function (text) {
      sheet = new CSSStyleSheet();
      sheet.replaceSync(text);
      waiting.splice(0).forEach(apply);
    })
    .catch(function () {});

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes') {
        handle(m.target);
        return;
      }
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.hasAttribute('data-zoppy-popup')) handle(node);
      });
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-zoppy-popup'],
  });
})();
